export default "__VITE_ASSET__CWultFR$__"